"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var SuccessSynced_exports = {};
__export(SuccessSynced_exports, {
  default: () => SuccessSynced_default
});
module.exports = __toCommonJS(SuccessSynced_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 25 24",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M19.3439 14.775C18.2456 17.488 15.5862 19.4001 12.4815 19.4001C11.5187 19.4001 10.7175 19.2818 9.95479 18.9998C9.1905 18.7173 8.43365 18.2589 7.57506 17.54C6.71532 16.8203 6.06517 16.1 5.6311 15.5612C5.48973 15.3857 5.37162 15.2299 5.27697 15.1001L6.90002 15.1001C7.23139 15.1001 7.50002 14.8315 7.50002 14.5001C7.50002 14.1687 7.23139 13.9001 6.90002 13.9001L4.40001 13.9001C3.7925 13.9001 3.30002 14.3926 3.30002 15.0001L3.30002 17.5001C3.30002 17.8315 3.56865 18.1001 3.90002 18.1001C4.23139 18.1001 4.50002 17.8315 4.50002 17.5001L4.50002 16.0643C4.56042 16.1428 4.62595 16.2263 4.6966 16.314C5.16879 16.9002 5.87282 17.6799 6.80473 18.4601C7.73778 19.2413 8.61232 19.7829 9.53871 20.1254C10.4667 20.4684 11.4155 20.6001 12.4815 20.6001C16.0917 20.6001 19.1809 18.3758 20.4562 15.2252C20.5805 14.9181 20.4323 14.5683 20.1252 14.4439C19.818 14.3196 19.4682 14.4678 19.3439 14.775Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M20.5 6.50015C20.5 6.16878 20.7686 5.90015 21.1 5.90015C21.4314 5.90015 21.7 6.16877 21.7 6.50015L21.7 9.00013C21.7 9.60764 21.2075 10.1001 20.6 10.1001L18.1 10.1001C17.7686 10.1001 17.5 9.83152 17.5 9.50015C17.5 9.16878 17.7686 8.90015 18.1 8.90015L19.7046 8.90014C19.6099 8.77036 19.4918 8.61453 19.3505 8.43905C18.9164 7.9002 18.2663 7.17999 17.4065 6.4602C16.5479 5.74137 15.7911 5.28296 15.0268 5.00042C14.2641 4.71848 13.4629 4.60015 12.5 4.60015C9.3954 4.60015 6.73592 6.51223 5.63771 9.22528C5.51337 9.53243 5.16357 9.68064 4.85641 9.55631C4.54925 9.43197 4.40104 9.08218 4.52538 8.77502C5.80071 5.6244 8.8899 3.40015 12.5 3.40015C13.5661 3.40015 14.5149 3.53182 15.4429 3.87487C16.3693 4.21733 17.2438 4.75892 18.1768 5.54009C19.1087 6.3203 19.8128 7.10009 20.285 7.68624C20.3629 7.78296 20.4346 7.87452 20.5 7.96006V6.50015Z",
      fill: "currentColor"
    }
  )
);
const SvgSuccessSynced = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var SuccessSynced_default = SvgSuccessSynced;
